<!--机具补贴情况-->
<template>
  <div class="location-number">
    <div class="title-name">
      <div class="item">机具品目</div>
      <div class="item fixed-width">台数(台)</div>
      <div class="item">补贴额(万元)</div>
    </div>
    <seamless-scroll
      class="locaiton-scroll"
      :data='machinerySubsidyList'
      :class-option="classOption"
    >
      <div
        :class="['machinery']"
        v-for="(item,index) in machinerySubsidyList"
        :key="index"
      >
      <p class="lo-name">{{item.mcc}}</p>
      <p class="lo-number fixed-width">{{item.numMachines || 0 | toThousandFilter}}</p>
      <p class="lo-number">{{item.centralSubsidy || 0 | toThousandFloatFilter }}</p>
      </div>
    </seamless-scroll>

  </div>
</template>

<script>
// import { getAreaMachineryNum } from '@/api/vehicleDistribution'
export default {
  name: 'machinerySubsidy',
  props: {
    machinerySubsidyList: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      classOption: {
        step: 0.5,
        limitMoveNum: 5
      },
 
    }
  },
  methods: {
 
  },
}
</script>
<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.location-number {
  height: 100%;
  width: 100%;
  padding-left: 9px;
  font-family: Microsoft YaHei;
  display: flex;
  flex-direction: column;
  .title-name {
    display: flex;
    align-items: center;
    height: vh(36);
    margin-top: vh(12);
    padding: 0 vw(24);
    background: rgba(44, 145, 79, 0.29);
    .item {
      font-weight: 400;
      font-size: fontSize(14);
      color: #50A96F;
      text-align: left;
      font-style: normal;
      text-transform: none;
      &:first-child {
        text-align: left;
        box-sizing: border-box;
        position: relative;
        flex: 1;
        margin-right: vw(6);
      }
      &:last-child {
        text-align: right;
        flex: 1;
      }
    }
  }
  .locaiton-scroll {
    height: 100%;
    overflow: hidden;
  }
  .machinery {
    display: flex;
    flex: 1;
    align-items: center;
    height: vh(36);
    padding: 0 vw(24);
    margin-bottom: vh(3);
    background: rgba(7, 51, 33, .25);
    font-size: fontSize(14);
    .lo-name {
      color: #ffffff;
      flex: 1;
      padding-right: vw(6);
    }
    .lo-number {
      color: #ffffff;
      text-align: left;
      font-style: normal;
      &:last-child {
        flex: 1;
        text-align: right;
        color: #5FFF97;
      }
    }
  }
  .machinery:nth-child(odd) {
    background: rgba(7, 51, 33, .6);
  }
  .fixed-width {
    width: vw(70);
  }
}
</style>
